var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 17.7083L17.6979 17.7083M3.55207 11.0312L11.0208 3.56246C11.2143 3.36876 11.4441 3.21509 11.697 3.11025C11.9499 3.00541 12.221 2.95145 12.4948 2.95145C12.7686 2.95145 13.0397 3.00541 13.2926 3.11025C13.5455 3.21509 13.7753 3.36876 13.9687 3.56246L22.9167 12.5L22.9167 22.9166L12.5 22.9166L3.55207 13.9687C3.16405 13.5784 2.94626 13.0503 2.94626 12.5C2.94626 11.9496 3.16405 11.4216 3.55207 11.0312Z",
    stroke: "#3373EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag2);
export default __webpack_public_path__ + "static/media/tag2.411feb44cf3c42ac4536b84aaa1b028a.svg";
export { ForwardRef as ReactComponent };